import React from "react";
import { graphql, Link } from "gatsby";
import Img from "gatsby-image";

import Layout from "../components/layout";
import SEO from "../components/seo";
import Share from "../components/Share"

class BlogPostTemplate extends React.Component {
  render() {

    // Sorts in decsending making previous post as next so inter changed it
    const { next, previous } = this.props.pageContext;
    const prevArticle = next && (
      <Link to={next.fields.slug} >
        <span>Previous Guide</span> <br />
        <h3>{next.frontmatter.title}</h3>
      </Link>
    )

    const nextArticle = previous && (
      <Link to={previous.fields.slug} >
        <span>Next Guide</span> <br />
        <h3>{previous.frontmatter.title}</h3>
      </Link>
    )

    const post = this.props.data.markdownRemark;
    const siteTitle = this.props.data.site.siteMetadata.title;

    return (
      <Layout location={this.props.location} title={siteTitle}>
        <SEO
          title={post.frontmatter.title}
          keywords={[
            `${post.frontmatter.tags}`,
            `league of legends wild rift`,
            `lol wild rift`,
            `wild rift`,
            `lol mobile`,
            `league of legends mobile`,
            `guides`,
            `runes`,
            `summoner spells`,
            `moba`,
            `moba mobile`
          ]}
          isBlogPost={true}
          postData={post}
          description={post.frontmatter.description || post.excerpt}
          image={post.frontmatter.thumbnail.childImageSharp.fluid}
          pathname={this.props.pageContext.slug}
        />
        <article
          className={`post-content ${post.frontmatter.thumbnail || `no-image`}`}
        >
          <header className="post-content-header">
            <h1 className="post-content-title">{post.frontmatter.title}</h1>
          </header>

          {post.frontmatter.description && (
            <p className="post-content-excerpt">
              {post.frontmatter.description}
            </p>
          )}

          {post.frontmatter.thumbnail && (
            <div className="post-content-image">
              <Img
                className="kg-image"
                fluid={post.frontmatter.thumbnail.childImageSharp.fluid}
                alt={post.frontmatter.title}
              />
            </div>
          )}

          <div
            className="post-content-body"
            dangerouslySetInnerHTML={{ __html: post.html }}
          />

          <footer className="post-content-footer">
            {/* There are two options for how we display the byline/author-info.
        If the post has more than one author, we load a specific template
        from includes/byline-multiple.hbs, otherwise, we just use the
        default byline. */}

          </footer>
          <Share
            socialConfig={{
              twitter: this.props.data.site.siteMetadata.social.twitter,
              config: {
                url: `${this.props.data.site.siteMetadata.siteUrl}${this.props.pageContext.slug}`,
                title: post.frontmatter.title,
              },
            }}
            tags={post.frontmatter.tags}
          />
          <div className="pagation">
            {prevArticle}
          </div>
          <div className="pagation pagationRight">
            {nextArticle}
          </div>

        </article>


      </Layout>
    );
  }
}

export default BlogPostTemplate;

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    site {
      siteMetadata {
        title
        author 
        social {
        twitter
      }
        siteUrl
      }
    }
    markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      excerpt(pruneLength: 160)
      html
      frontmatter {
        title
        date(formatString: "MMMM DD, YYYY")
        description
        tags
        thumbnail {
          childImageSharp {
            fluid(maxWidth: 1360) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`;
